module.exports = __webpack_public_path__ + "static/media/2.b4c81435.jpg";